<template>
  <div v-if="showPrompt">
    <b-modal ref="sessionTimeOutModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc centered>
      <div style="margin-top: -15px;">
        <h6>
          <p><strong>Session Timeout</strong></p>
        </h6>
      </div>
      <div>
        <p>Due to inactivity, you will soon be logged out.</p>
      </div>
      <div class="w-100 mt-5">
        <a href="javascript://" @click="extend" class="float-right mr-2" style="font-size: 15px;"><strong>EXTEND SESSION</strong></a>
        <a href="javascript://" @click="cancel" class="float-right mr-3" style="font-size: 15px;"><strong>LOG OUT NOW ({{counter}})</strong></a>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'session-idle-modal',
    data: () => {
      return {
        time: 60000,
        showPrompt: false,
        timeoutTimer: null
      }
    },
    created () {
      this.polling()
    },
    beforeDestroy () {
      if (this.timeoutTimer) {
        clearInterval(this.timeoutTimer)
      }
    },
    computed: {
      counter () {
        let count = this.time / 1000
        return ('0' + count).slice(-2)
      }
    },
    methods: {
      polling () {
        this.$parent.loadUserLogout()
        /*
        this.timeoutTimer = setInterval(() => {
          this.time -= 1000
          if (this.time < 1) {
            clearInterval(this.timeoutTimer)
            this.$parent.loadUserLogout()
          }
          if (this.showPrompt) {
            this.$refs.sessionTimeOutModal.show()
          }
          this.$parent.isShowSessionTimeoutPrompt = true
        }, 1000)
        */
      },
      cancel () {
        this.$refs.sessionTimeOutModal.hide()
        this.$parent.isShowSessionTimeoutPrompt = false
        this.$store.commit('idleVue/IDLE_CHANGED', false)
        clearInterval(this.timeoutTimer)
        this.$parent.loadUserLogout()
      },
      extend () {
        this.$refs.sessionTimeOutModal.hide()
        clearInterval(this.timeoutTimer)
        this.$parent.extendCurrentSession()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/login/components/SessionIdleModal.vue